import React from "react";
import { Layout } from "antd";

const { Footer: AntFooter } = Layout;

const Footer: React.FC = () => {
  return (
    <AntFooter
      className="app-footer"
      style={{
        backgroundColor: "#FFF",
        textAlign: "center",
        padding: "10px",
        marginTop: "auto",
        fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
        fontSize: "14px",
        fontWeight: "400",
        letterSpacing: "0.5px",
        color: "#777",
        borderTop: "none",
        marginLeft: "300px",
        position: "fixed",
        bottom: "0",
        left: "0",
        right: "0",
        height: "84px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      City of New Orleans 2025
    </AntFooter>
  );
};

export default Footer;
